// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vuHehi4xZ1VhQuUCRyKJ div ul li > hr {
  border-color: var(--grey-color-90) !important;
}
.vuHehi4xZ1VhQuUCRyKJ div ul li > div > div:nth-child(1) {
  background-color: var(--grey-color-200) !important;
  color: var(--grey-color-90) !important;
  border-color: var(--grey-color-90) !important;
}

.Cxf4AGd9046Stnnk0J8X {
  height: 10px;
}

.K9cpdWVtuKZjiszhVvON {
  display: flex;
  justify-items: flex-start;
  gap: 10px;
  font-size: 24px;
  font-style: normal;
  font-weight: 800;
  line-height: 32px;
}

.YzBfLNYG3UEV2tqVJ93d {
  height: 24px;
  width: 24px;
  border-radius: 24px;
  padding: 2px;
  margin-top: 7px;
  background-color: var(--grey-color-10);
  cursor: pointer;
}

.HIqiudgDuWfoPgxyXyfQ {
  position: relative;
  right: 12px;
  margin: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/StepManager/StepManager.module.scss"],"names":[],"mappings":"AACE;EACE,6CAAA;AAAJ;AAEE;EACE,kDAAA;EACA,sCAAA;EACA,6CAAA;AAAJ;;AAIA;EACE,YAAA;AADF;;AAIA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EAEA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,sCAAA;EACA,eAAA;AAFF;;AAKA;EACE,kBAAA;EACA,WAAA;EACA,oBAAA;AAFF","sourcesContent":[".stepper {\n  & div ul li > hr {\n    border-color: var(--grey-color-90) !important;\n  }\n  & div ul li > div > div:nth-child(1) {\n    background-color: var(--grey-color-200) !important;\n    color: var(--grey-color-90) !important;\n    border-color: var(--grey-color-90) !important;\n  }\n}\n\n.whiteSpace {\n  height: 10px;\n}\n\n.title {\n  display: flex;\n  justify-items: flex-start;\n  gap: 10px;\n\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 800;\n  line-height: 32px;\n}\n\n.pencil {\n  height: 24px;\n  width: 24px;\n  border-radius: 24px;\n  padding: 2px;\n  margin-top: 7px;\n  background-color: var(--grey-color-10);\n  cursor: pointer;\n}\n\n.content {\n  position: relative;\n  right: 12px;\n  margin: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepper": `vuHehi4xZ1VhQuUCRyKJ`,
	"whiteSpace": `Cxf4AGd9046Stnnk0J8X`,
	"title": `K9cpdWVtuKZjiszhVvON`,
	"pencil": `YzBfLNYG3UEV2tqVJ93d`,
	"content": `HIqiudgDuWfoPgxyXyfQ`
};
export default ___CSS_LOADER_EXPORT___;
